import type { DemoRuleIntegrationAdapter, RuleIntegrationRegistry } from "./ruleIntegrationTypes";
import { getRegisteredStatementRuleIntegrationAdapters } from "./policies/statementRulePolicyRegistry";
import { getRegisteredTableTextRuleIntegrationAdapters } from "./policies/tableTextRulePolicyRegistry";

const REGISTERED_RULE_ADAPTERS: RuleIntegrationRegistry = {
    ...getRegisteredStatementRuleIntegrationAdapters(),
    ...getRegisteredTableTextRuleIntegrationAdapters(),
};

export const getRuleIntegrationAdapter = (ruleId: string): DemoRuleIntegrationAdapter | undefined =>
    REGISTERED_RULE_ADAPTERS[ruleId];

export const getRegisteredRuleIntegrationAdapters = (): RuleIntegrationRegistry => REGISTERED_RULE_ADAPTERS;
